<div id="matDialogContent">
  <div id="dialogHeader">
    <strong>{{title}}</strong>
    <mat-icon tabindex="0" (keydown.enter)="dialog.closeAll()" (click)="dialog.closeAll()">close</mat-icon>
  </div>
  <div id="dialogContent">
    <ng-template #container></ng-template>
  </div>
</div>
